<template>
  <div id="basic-info" class="card mt-4">
    <div class="card-header">
      <h5>{{ $t('settings.Mail_template') }}</h5>
    </div>
    <div class="card-body pt-0">
      <div class="row">        
          <div class="col-4">
              <div class="input-group input-group-static null">
                  <label>{{ $t('settings.Name') }} *</label>
                  <input v-model="state.name" type="text" class="form-control form-control-default" :placeholder="$t('settings.Name')">
                  <span v-if="v$.name.$error" class="text-sm text-danger">
                      {{ v$.name.$errors[0].$message }}
                  </span>
              </div>
          </div>
          <div class="col-8">
              <div class="input-group input-group-static null">
                  <label>{{ $t('settings.Subject') }} *</label>
                  <input v-model="state.subject" type="text" class="form-control form-control-default" :placeholder="$t('settings.Subject')">
                  <span v-if="v$.subject.$error" class="text-sm text-danger">
                      {{ v$.subject.$errors[0].$message }}
                  </span>
              </div>
          </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
            <div class="input-group input-group-static null">
                <label>{{ $t('settings.Body') }} *</label>
                <textarea class="form-control form-control-default" :rows="10"
                    v-model="state.body"
                    :placeholder="$t('settings.Description')"></textarea>
                <span v-if="v$.body.$error" class="text-sm text-danger">
                    {{ v$.body.$errors[0].$message }}
                </span>
            </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 mt-6">
        <input type="hidden" v-model="state.id" class="form-control">
        <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
        <button v-on:click="updateMailTemplate" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Update') }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import useValidate from '@vuelidate/core'
import { required, helpers, } from '@vuelidate/validators'
import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n';

export default {
  name: "MailTemplateDetail",
  setup() {
    const { t } = useI18n()

    const state = reactive({      
      id: '',
      name: '',
      subject: '',      
      body: '',
      mailtemplate: []
    })

    const rules = computed(() => {
      return {
        name: { required: helpers.withMessage(t('common.Required'), required) },
        subject: { required: helpers.withMessage(t('common.Required'), required) },
        body: { required: helpers.withMessage(t('common.Required'), required) }        
      }
    })

    const v$ = useValidate(rules, state)

    return {
      state,
      v$
    }
  },
  components: {
  },
  data() {
    return {
      gets: [],
      error: '',
    };
  },
  async mounted() {
    this.id = this.$route.params.id;
    await this.fetchMailTemplateData(this.$route.params.id);    
  },
  methods: {
    async fetchMailTemplateData(id) {
      try {
        
        this.$store.commit('setShowLoading', true);

        const response = await axios.get(`mailtemplate/${id}`);
        this.gets = response.data;

        if (this.gets.success) {
          this.state.mailtemplate = this.gets.data;
          this.state.id = this.state.mailtemplate.id;
          this.state.name = this.state.mailtemplate.name;
          this.state.subject = this.state.mailtemplate.subject;
          this.state.body = this.state.mailtemplate.body;
          
        } else {
          this.$showError('errors.Contact_system_admin');
        }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      } finally {      
        this.$store.commit('setShowLoading', false);
      }
    },
    async updateMailTemplate() {
      try {
        this.$store.commit('setShowLoading', true);

        this.v$.$validate();
        console.log(this.v$.$error);

        if (!this.v$.$error) {
          const response = await axios.put('mailtemplate/update', {
            "id": this.state.id,
            "name": this.state.name,
            "subject": this.state.subject,
            "body": this.state.body,
          });
          this.gets = response.data;

          if (this.gets.success) {
            this.$showSuccess('errors.Success_mail_template_updated_successfully');
            this.$router.push('/settings');
          } else {
            this.$showError('errors.Contact_system_admin');            
          }
        }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      } finally {
        this.$store.commit('setShowLoading', false);
      }
    },
  }
};
</script>